export const SMALL_SCREEN_IN_PX = 812

export const media = {
  mobile: `(max-width: ${SMALL_SCREEN_IN_PX}px)`,
}
